module.exports = __webpack_public_path__ + "static/media/py.795e6d0e.svg";